/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { easyPost } from './utils';

//  配置
export const getCommonConfig = easyPost('user.banner.config');

//  批量报名活动
export const enrollActicity = easyPost('marketing.promoactivity.batchApplyActivity');

//  获取活动状态和用户参与记录
export const getUserAndActivityInfo = easyPost('marketing.promoactivity.batchQueryUserActivityStatus');

export const getUserBikeCards = easyPost('bike.wx.main.info', {
  api: config.BIKE_API, risk: true,
});

export const getUserEbikeCards = easyPost('user.ev.ridecard.mycard', {
  api: config.EBIKE_API,
});
